import React from 'react';
import { styled } from '@mui/material';
import { 
  Check, X, AlertTriangle, Loader2, Activity, ChevronDown, ChevronUp, 
  Trash2, Send, Settings, Code, Zap, FileText, Plus, Eye, Calendar, 
  Globe, Tag, Type, PlayCircle, Link, RefreshCw, User, Phone, Building, 
  Clock, MessageCircle
} from 'lucide-react';

const iconMap = {
  check: Check,
  x: X,
  'alert-triangle': AlertTriangle,
  loader: Loader2,
  activity: Activity,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  trash: Trash2,
  send: Send,
  settings: Settings,
  code: Code,
  zap: Zap,
  'file-text': FileText,
  plus: Plus,
  eye: Eye,
  calendar: Calendar,
  globe: Globe,
  tag: Tag,
  type: Type,
  'play-circle': PlayCircle,
  link: Link,
  'refresh-cw': RefreshCw,
  user: User,
  phone: Phone,
  building: Building,
  clock: Clock,
  'message-circle': MessageCircle
} as const;

export interface IconProps {
  name: keyof typeof iconMap;
  className?: string;
  size?: number;
}

const StyledIcon = styled('div')<{ size?: number }>(({ theme, size }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: size ? `${size}px` : '1.25rem',
  height: size ? `${size}px` : '1.25rem',
  '& svg': {
    width: '100%',
    height: '100%',
  }
}));

export const Icon: React.FC<IconProps> = ({ name, className = '', size }) => {
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <StyledIcon className={className} size={size}>
      <IconComponent />
    </StyledIcon>
  );
};
